export default __webpack_public_path__ + "static/media/EM0420.34I-22655_-16400_0.eb66d9f9.jpg";